import './AppSearchBar.less';
import { Select, SearchInput, SelectOptionProps } from '@/components';
import { useState } from 'react';
import classnames from 'classnames';

export interface AppSearchBarProp {
  onFocus?: () => void;
  onSearch?: (value: string) => void;
  onChange?: (value: string) => void;
  onSelect?: (value: string) => void;
  autocompleteOptions?: SelectOptionProps[];
}

export function AppSearchBar(
  props: AppSearchBarProp &
    Omit<React.HTMLAttributes<HTMLDivElement>, 'onChange' | 'onSelect'>,
) {
  const {
    onSearch = () => {},
    onChange = () => {},
    onSelect = () => {},
    onFocus = () => {},
    autocompleteOptions = [],
  } = props;
  const [val, setVal] = useState<string>('');

  const handleInputSearch = (value: string) => {
    onSearch(value);
  };

  const handleInputChange = (value: string) => {
    setVal(value);
    onChange(value);
  };

  const handleSelectChange = (value: string) => {
    setVal(value);
    onSelect(value);
  };

  const handleFocus = () => {
    onFocus();
  };

  return (
    <Select
      className="app-searchbar-wrapper"
      slideDownByOptions
      onFocus={handleFocus}
      onChange={handleSelectChange}
      options={autocompleteOptions}
      customContent={
        <SearchInput
          value={val}
          className={classnames('app-searchbar', {
            filled: val,
          })}
          placeholder={window.trans('searchPlaceholder')}
          onSearch={handleInputSearch}
          onChange={handleInputChange}
        />
      }
    ></Select>
  );
}
